import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../../../shared/components/features/widget/Widget";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import googleMeetImgTeacher from "../../../../assests/googleMeet/googleMeetWidgetTeacherMeetNotActive.png";
import classes from "./GoogleMeetWidgetTeacher.module.css";
import pathRouts from "../../../../shared/enums/pathRoute";

const GoogleMeetWidgetTeacher = () => {

    const { texts } = useSelector(state => state.translate);
    const { userDetails } = useSelector(state => state.auth);

    return (
        <Widget
            width={250}
            height={250}
            title={texts.googleMeet}
            icon={iconsList.googleMeet}
            mainLink={`/${pathRouts.GOOGLEMEET}`}
            color="#7ED0FF"
            className={classes.GoogleMeetWidgetTeacher}
        >
            <div className={classes.WidgetContent}>
                <img src={googleMeetImgTeacher} alt={texts.googleMeet} />
                <div className={classes.GoogleMeetText}>
                    {texts.googleMeetTeacherWidgetDescription}
                </div>
            </div>
        </Widget>
    );
};

export default GoogleMeetWidgetTeacher;
